import { render, staticRenderFns } from "./ActiveTemporaryItems.vue?vue&type=template&id=48c2815d"
import script from "./ActiveTemporaryItems.vue?vue&type=script&lang=js"
export * from "./ActiveTemporaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports